// src/components/Notification.js - Notification component
import { useEffect } from 'react';

const Notification = ({ message, type = 'info', onClose, duration = 5000 }) => {
  useEffect(() => {
    if (duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [duration, onClose]);

  // Ensure message is always a string
  const messageText = typeof message === 'string' 
    ? message 
    : (message?.message || (typeof message === 'object' ? JSON.stringify(message) : String(message)) || 'An error occurred');

  const bgColors = {
    success: 'bg-green-50 dark:bg-green-900/20 border-green-200 dark:border-green-800 text-green-800 dark:text-green-400',
    error: 'bg-red-50 dark:bg-red-900/20 border-red-200 dark:border-red-800 text-red-800 dark:text-red-400',
    warning: 'bg-yellow-50 dark:bg-yellow-900/20 border-yellow-200 dark:border-yellow-800 text-yellow-800 dark:text-yellow-400',
    info: 'bg-shayek-primary/10 dark:bg-shayek-primary/20 border-shayek-primary/30 dark:border-shayek-primary/40 text-shayek-primary dark:text-shayek-red-light'
  };

  const iconColors = {
    success: 'text-green-400',
    error: 'text-red-400',
    warning: 'text-yellow-400',
    info: 'text-shayek-primary dark:text-shayek-red-light'
  };

  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ'
  };

  return (
    <div className={`fixed top-4 right-4 z-50 max-w-md w-full ${bgColors[type]} border rounded-lg shadow-lg p-4 flex items-start space-x-3 animate-slide-in`}>
      <div className={`flex-shrink-0 text-xl ${iconColors[type]}`}>
        {icons[type]}
      </div>
      <div className="flex-1">
        <p className="text-sm font-medium">{messageText}</p>
      </div>
      <button
        onClick={onClose}
        className="flex-shrink-0 text-gray-400 hover:text-gray-600"
      >
        ✕
      </button>
    </div>
  );
};

export default Notification;

